module.exports = __webpack_public_path__ + "static/media/Acheive11.4223de19.jpeg";